const SCORM_UPLOAD_STATUS = {
  ERROR    : 'ERROR',
  RUNNING  : 'RUNNING',
  COMPLETE : 'COMPLETE',
  TIMEOUT  : 'TIMEOUT'
};

module.exports = {
  SCORM_UPLOAD_STATUS
};
